import Home from './Home';
import Login from './Login';
import NotFound from './NotFound';
import Venda from './Venda';

export { Home, Login, NotFound, Venda }



// WEBPACK FOOTER //
// ./src/Views/index.js